var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4354 6.21995L23.7779 2.5625L14.9993 11.3411L6.22141 2.56322L2.56396 6.22067L11.3419 14.9986L2.56472 23.7757L6.22217 27.4332L14.9993 18.656L23.7772 27.4339L27.4346 23.7764L18.6568 14.9986L27.4354 6.21995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputClearIcon);
export default __webpack_public_path__ + "static/media/input-clear-icon.ae8734de7dafdd248d8b0114397ce28c.svg";
export { ForwardRef as ReactComponent };